import EditorWrapper from './EditorWrapper';
import EditorLabel from './EditorLabel';
import EditorTextField from './EditorTextField';

// TODO use namespace? (also for similar mechanisms)
const KeyValueEditor = {
  Wrapper: EditorWrapper,
  Label: EditorLabel,
  TextField: EditorTextField,
};

export default KeyValueEditor;
